import { CategoryT } from '@common/types';
import { CarrierDetails } from '@store/carriers';

export const CarrierStatuses = [
  'Active',
  'Inactive',
  'Pending',
  'Out of Business',
  'Conditional',
  'Incomplete',
  'Unvetted',
];

export const BillingTermsOptions = [
  'Due Upon Receipt',
  'Net 10',
  'Net 15',
  'Net 31',
  'Net 35',
  'Net 45',
  'Quick Pay',
];

export const VendorHoldReasonTypes = [
  'Agent',
  'Claims',
  'Damages',
  'Missing LOR/NOA',
  'Missing PPWK',
  'Rate Discrepancy',
  'Other',
];

export const CarrierDetailsEquipmentTypes = [
  {
    id: 79,
    category: 'BT',
    name: 'Beam Trailer',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 65,
    category: 'B-TR',
    name: 'B-TR - B-Train/Supertrain',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 62,
    category: 'CN',
    name: 'CN, Conestoga',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 63,
    category: 'CONT',
    name: 'CONT, Container Trailer',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 3,
    category: 'DD',
    name: 'DD, Double Drop',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 83,
    category: 'DDE',
    name: 'Double Drop Extended',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 92,
    category: 'LA',
    name: 'Drop Deck Landoll',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 80,
    category: 'DR',
    name: 'Drop Side',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 75,
    category: 'DT',
    name: 'DT/Dump Trailer',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 78,
    category: 'ST',
    name: 'Extendable Flatbed',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 1,
    category: 'F',
    name: 'F, Flatbed',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 70,
    category: 'F/SD',
    name: 'F/SD, Flatbed/StepDeck',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 94,
    category: 'F48',
    // eslint-disable-next-line quotes
    name: "F48, Flatbed 48'",
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 74,
    category: 'F/R53',
    // eslint-disable-next-line quotes
    name: "FR/53' Flat or Reefer",
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 66,
    category: 'FVR',
    name: 'FVR, Flat, Van or Reefer',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 4,
    category: 'FWS',
    name: 'FWS, Flat w/Sides',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 5,
    category: 'HS',
    name: 'HS, Hot Shot',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 69,
    category: 'HSF',
    name: 'HSF, Hot Shot Flat',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 68,
    category: 'HSV',
    name: 'HSV, Hot Shot Van',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 6,
    category: 'LB',
    name: 'LB, Lowboy',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 84,
    category: 'LPS',
    name: 'Low Profile Step Deck',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 64,
    category: 'MAXI',
    name: 'MAXI, Maxi or Double Flat Trailers',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 103,
    category: 'OT',
    name: 'OT, Van Open Top',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 76,
    category: 'NU',
    name: 'Pneumatic Dry Bulk',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 7,
    category: 'PO',
    name: 'PO, Power Only',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 8,
    category: 'R',
    name: 'R, Reefer',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 96,
    category: 'R2',
    name: 'R2, Reefer Double',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 9,
    category: 'R53',
    // eslint-disable-next-line quotes
    name: "R53, 53' Reefer",
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 95,
    category: 'RA',
    name: 'RA, Reefer with Air ride',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 90,
    category: 'RV',
    name: 'Reefer or Vented Van',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 91,
    category: 'RGNE',
    name: 'Removable Goose. Ext.',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 10,
    category: 'RGN',
    name: 'RGN, Removable Goose Neck',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 11,
    category: 'SD',
    name: 'SD, Step Deck',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 73,
    category: 'SD/RGN',
    name: 'SD/RGN, Step Deck or RGN',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 81,
    category: 'MV',
    name: 'Sprinter Van',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 82,
    category: 'SDL',
    name: 'Stepdeck with Ramps',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 93,
    category: 'SDS',
    name: 'Stepdeck with Sides',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 14,
    category: 'SV',
    name: 'SV, Straight Van',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 97,
    category: 'TA',
    name: 'TA, Tanker Aluminum',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 77,
    category: 'T',
    name: 'Tankers',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 106,
    category: 'TL',
    name: 'TL, Trailer',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 98,
    category: 'TS',
    name: 'TS, Tanker Steel',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 13,
    category: 'V',
    name: 'V, Van',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 85,
    category: 'V10',
    // eslint-disable-next-line quotes
    name: "V10, 10' Van",
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 86,
    category: 'V15',
    // eslint-disable-next-line quotes
    name: "V15, 15' Van",
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 100,
    category: 'V2',
    name: 'V2, Van Double',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 87,
    category: 'V20',
    // eslint-disable-next-line quotes
    name: "V20, 20' Van",
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 88,
    category: 'V26',
    // eslint-disable-next-line quotes
    name: "V26, 26' Van",
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 105,
    category: 'V3',
    name: 'V3, Van Triple',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 89,
    category: 'V35',
    // eslint-disable-next-line quotes
    name: "V35, 35' Van",
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 18,
    category: 'V53',
    // eslint-disable-next-line quotes
    name: "V53, 53' Van",
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 104,
    category: 'VB',
    name: 'VB, Van with Roller bed',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 61,
    category: 'VC',
    name: 'VC, Van with Curtains',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 72,
    category: 'VF',
    name: 'VF, Van or Flat',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 101,
    category: 'VI',
    name: 'VI, Van Insulated',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 102,
    category: 'VL',
    name: 'VL, Van Logistics',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 67,
    category: 'VR',
    name: 'VR, Van Or Reefer',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 17,
    category: 'VV',
    name: 'VV, Vented Van',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
  {
    id: 99,
    category: 'VW',
    name: 'VW, Van blanket wrap',
    dATEquipment: null,
    createdDate: null,
    createdBy: null,
  },
];

export const CarrierContactVerificationStatuses = {
  Unverified: 0,
  UserVerified: 1,
  VendorVerified: 2,
};

export const INITIAL_CARRIER_DETAILS_STATE: CarrierDetails = {
  accountingSysId: null,
  allowAdvances: false,
  alreadySetup: false,
  averageRating: 0,
  billingTerms: '',
  blacklist: null,
  brokerAuthority: false,
  certifications: [],
  canAddress: {
    achAccount: '',
    achRouting: '',
    countryCode: 'CA',
    enabled: false,
    factoringCompany: null,
    factoringCompanyId: null,
    id: 0,
    mailingAddress1: '',
    mailingAddress2: '',
    mailingCity: '',
    mailingStateOrProvince: '',
    mailingZip: '',
    operationType: 'Insert',
    physicalAddress1: '',
    physicalAddress2: '',
    physicalCity: '',
    physicalStateOrProvince: '',
    physicalZip: '',
  },
  cargoExpiration: '',
  cargoInsuranceCompany: '',
  cargoLimit: 0,
  cargoPolicyNumber: '',
  comments: [],
  commonAuthority: false,
  conditionalActionPlanReceived: false,
  contacts: [],
  createdDate: '',
  contractAuthority: false,
  contractDocument: null,
  contractSignedBy: null,
  contractSignedDate: '',
  corporatePhoneNumber: '',
  currentContactId: 0,
  documentPath: '',
  documents: [],
  dot: null,
  emailCopy: '',
  equipments: [],
  factor: false,
  falloutCount: 0,
  bounceSummary: {
    reasons: [],
    hauledLoads: 0,
    totalBounces: 0,
    totalAssignments: 0,
    bouncePercentage: 0,
    windowMonths: 12,
  },
  hasExpiredCargoInsurance: false,
  hasExpiredLiabilityInsurance: false,
  hazmatCertified: false,
  id: 0,
  isFavorite: false,
  lanes: [],
  liabilityExpiration: '',
  liabilityInsuranceCompany: '',
  liabilityLimit: 0,
  liabilityPolicyNumber: '',
  ltlEnabled: false,
  ltlRateNote: '',
  ltlTerminalLink: '',
  maxLiabilities: [],
  mc: null,
  modifiedDate: '',
  name: '',
  mode: '',
  needs1099: false,
  numberOfLoads: 0,
  numRatings: 0,
  officeRating: 0,
  operationType: 'Insert',
  overallMaxLiabilityClass: '',
  ratings: [],
  overallMaxNewLiability: null,
  overallMaxUsedLiability: null,
  paymentTermDays: 0,
  reeferInsurance: false,
  remitTo: '',
  safetyRating: null,
  safetyWarnings: null,
  smartWayCertified: false,
  status: '',
  taxId: '',
  taxIDVerificationDate: null,
  transfloEnabled: false,
  usaAddress: {
    achAccount: '',
    achRouting: '',
    countryCode: 'US',
    enabled: true,
    factoringCompany: null,
    factoringCompanyId: null,
    id: 0,
    mailingAddress1: '',
    mailingAddress2: '',
    mailingCity: '',
    mailingStateOrProvince: '',
    mailingZip: '',
    operationType: 'Insert',
    physicalAddress1: '',
    physicalAddress2: '',
    physicalCity: '',
    physicalStateOrProvince: '',
    physicalZip: '',
  },
  mexAddress: {
    achAccount: '',
    achRouting: '',
    countryCode: 'MX',
    enabled: false,
    factoringCompany: null,
    factoringCompanyId: null,
    id: 0,
    mailingAddress1: '',
    mailingAddress2: '',
    mailingCity: '',
    mailingStateOrProvince: '',
    mailingZip: '',
    operationType: 'Insert',
    physicalAddress1: '',
    physicalAddress2: '',
    physicalCity: '',
    physicalStateOrProvince: '',
    physicalZip: '',
  },
  vendorHold: false,
  vendorHoldDescription: '',
  vendorHoldReason: '',
  notes: null,
  workersCompExpiration: '',
  workersCompInsuranceCompany: '',
  workersCompLimitDisease: 0,
  workersCompLimitEachAccident: 0,
  workersCompLimitPolicy: 0,
  workersCompPolicyNumber: '',
  hasWatchDogAlerts: false,
  hasIdentityAlerts: false,
  highwayUrl: null,
  requireMacropointTracking: null,
  shipperVerifyMCDotNumber: null,
  nonUs: false,
  onboardingVendorCarrierExclusion: undefined,
  isValid: false,
  carrierInsights: [],
  carrierInsurances: [],
  highValueCertified: false,
  operatingService: '',
  vendorAssessment: '',
  lessThanThreeLoads: false,
  billingContactEmail: '',
  carrierHighwayRuleAssociations: [],
  intrastateFullyPassed: false,
  interstateFullyPassed: false,
  highValueCargoFullyPassed: false,
  refrigeratedFullyPassed: false,
  caRefrigeratedFullyPassed: false,
  hazmatFullyPassed: false,
  canadianCrossBorderFullyPassed: false,
  coBrokerFullyPassed: false,
  carrierReactivationRequestCacheItemViewModel: null,
  highwayRateConRecipients: [],
};

export const CarrierDetailsFileUploadCategories: CategoryT[] = [
  {
    title: 'Onboarding Documents',
    slug: 'onboarding',
    categoryKey: 'OnboardingDocuments',
  },
  {
    title: 'Safety Letters',
    slug: 'safety-letters',
    categoryKey: 'SafetyLetters',
  },
  {
    title: 'Other',
    slug: 'other',
    categoryKey: 'Other',
  },
];

export const CarrierBillingFileUploadCategories: CategoryT[] = [
  {
    title: 'Factoring Documents',
    slug: 'factoring-documents',
    categoryKey: 'FactoringDocuments',
  },
  {
    title: 'Other',
    slug: 'other-billing',
    categoryKey: 'OtherBilling',
  },
];
